import React from "react";
import {
    Button,
    Form,
    FormGroup,
    Col,
    Label,
    Row,
    Input
} from "reactstrap";
import { DatePicker } from "../../../components/DatePicker";
import "./index.scss";
import SelectList from "../../../components/SelectList/selectList";

const SearchPanel = ({
    searchQuery,
    handleChange,
    selectChange,
    channel,
    channels,
    search,
    onChange,
    startDate,
    endDate,
    requesting,
    changeDatePicker,
    onSearch,
    notification,
    notifications
}) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            {/* <Container> */}
            <Row>
                <Col xs="12" md="3">
                    <FormGroup>
                        <Label for="date">Start Date</Label>
                        <DatePicker
                            date={startDate}
                            onChange={(date) => changeDatePicker(date, "startDate")}
                        />
                    </FormGroup>
                </Col>
                <Col xs="12" md="3">
                    <FormGroup>
                        <Label for="date">End Date</Label>

                        <DatePicker
                            date={endDate}
                            onChange={(date) => changeDatePicker(date, "endDate")}
                        />
                    </FormGroup>
                </Col>
                <Col xs="12" md="3">
                    <FormGroup className="mb-4">
                        <Label>Channel</Label>
                        <SelectList
                            data={channels}
                            valueKey={"id"}
                            textField={"name"}
                            selectValue={channel}
                            onValueChange={(event) => {
                                selectChange(event, "channel");
                            }}
                            placeholder={"Select channel..."}
                        />
                    </FormGroup>
                </Col>
                <Col xs="12" md="3">
                <FormGroup className="mb-4">
                        <Label>Notification Type</Label>
                        <SelectList
                            data={notifications}
                            valueKey={"id"}
                            textField={"name"}
                            selectValue={notification}
                            onValueChange={(event) => {
                                selectChange(event, "notification");
                            }}
                            placeholder={"Select Type..."}
                        />
                    </FormGroup>
                </Col>
                <Col xs="12" md="3" className={"search-button"}>
                    <Button
                        // size="lg"
                        color="success"
                        className="btn-rounded px-4 text-white"
                        disabled={requesting}
                        onClick={() => onSearch(1)}
                    >
                        {requesting ? `Searching...` : `Search`}
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default SearchPanel;
